import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { DeckAccordion } from 'pages/deck/common/DeckAccordion'
import { forwardRef } from 'react'

export const OtherKitsMaintenanceTable = forwardRef(
  ({ title, deckRevision, otherKitsMaintenance, ...otherProps }, ref) => {
    const theme = useTheme()

    if (!otherKitsMaintenance?.length) {
      return null
    }

    return (
      <Box ref={ref} mb={1} {...otherProps}>
        <DeckAccordion showTooltip={false} title={title || 'Other Kits Maintenance'}>
          <TableContainer
            sx={{
              maxHeight: '300px',
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '2px',
                height: '2px'
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: theme.palette.supporting.dark
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.supporting.pale,
                borderRadius: 2
              }
            }}>
            <Table stickyHeader sx={{ borderCollapse: 'collapse' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Material number</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Quantity</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {otherKitsMaintenance.map((item) => {
                  const kit = deckRevision.Kits.find((k) => k.MaterialNumber === item.MaterialNumber)
                  return (
                    <TableRow key={item.MaterialNumber}>
                      <TableCell>{item.MaterialNumber}</TableCell>
                      <TableCell>{kit?.MaterialDescription || 'N/A'}</TableCell>
                      <TableCell>{item.Quantity}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DeckAccordion>
      </Box>
    )
  }
)

OtherKitsMaintenanceTable.displayName = 'OtherKitsMaintenanceTable'
